<template>
  <div class="upper-limb-orthosis-step-one">
    <v-layout justify-space-between>
      <v-flex sm6>
        <v-layout wrap>
          <v-flex>
            <v-radio-group
              v-model="form.brace_type"
              class="mb-0 mt-0"
              hide-details
              row
            >
              <v-radio
                class="mb-1 mt-1"
                label="Atelle de main"
                value="HAND_BRACE"
              />
              <v-radio
                class="mb-1 mt-1"
                label="Atelle de bras"
                value="ARM_BRACE"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-layout class="mb-0 mt-0">
        <v-flex
          row
          class="mb-0 mt-0"
        >
          <v-checkbox
            v-model="form.idc_right"
            class="mb-0 mt-0 mr-3"
            hide-details
            label="DROITE"
          />
          <v-checkbox
            v-model="form.idc_left"
            class="mb-0 mt-0 ml-3"
            hide-details
            label="GAUCHE"
          />
        </v-flex>
      </v-layout>
    </v-layout>

    <v-layout
      class="mt-0"
      justify-space-between
    >
      <v-checkbox
        v-model="form.idc_rigid"
        class="mt-0"
        hide-details
        label="RIGIDE"
      />
      <v-checkbox
        v-model="form.idc_articulation"
        class="mt-0"
        hide-details
        label="ARTICULE"
      />
      <v-checkbox
        v-model="form.idc_on_wrist"
        class="mt-0"
        hide-details
        label="AU POIGNET"
      />
      <v-checkbox
        v-model="form.idc_at_elbow"
        class="mt-0"
        hide-details
        label="AU COUDE"
      />
      <v-checkbox
        v-model="form.idc_none"
        class="mt-0 mb-3"
        hide-details
        label="AUCUN"
      />
    </v-layout>
    <v-layout
      align-center
      mb-6
    >
      <v-flex>
        <v-text-field
          v-model="form.model"
          label="Modèle :"
          maxlength="50"
          hide-details
          outlined
          clearable
        />
      </v-flex>
      <h4 />
    </v-layout>

    <v-layout
      justify-space-between
      hide-details
      class="mb-6 mt-6"
    >
      <v-flex sm6>
        <v-btn
          block
          @click="$emit('schematic-with-elbow')"
        >
          Schéma avec coude
        </v-btn>
      </v-flex>
      <v-flex sm6>
        <v-btn
          block
          @click="$emit('schematic-without-elbow')"
        >
          Schéma sans coude
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mt-6
    >
      <v-flex sm6>
        <v-switch
          v-model="form.idc_exterior_finishing"
          hide-details
          label="Finition Extérieure :"
          class="title mb-3"
          @change="clearExtFinishingFields"
        />
        <v-layout justify-space-between>
          <v-flex sm6>
            <v-text-field
              v-model="form.aquaplast"
              v-validate="'numeric|max:4'"
              data-vv-name="(Finition Ext) Aquaplast"
              :class="{ error: errors.has('(Finition Ext) Aquaplast') }"
              type="number"
              class="mb-2"
              label="AQUAPLAST mm"
              :disabled="!form.idc_exterior_finishing"
              outlined
              hide-details
            />
          </v-flex>
          <v-flex sm6>
            <v-text-field
              v-model="form.sansplint"
              v-validate="'numeric|max:4'"
              data-vv-name="(Finition Ext) Sansplint"
              :class="{ error: errors.has('(Finition Ext) Sansplint') }"
              label="SANSPLINT mm"
              type="number"
              :disabled="!form.idc_exterior_finishing"
              outlined
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-flex sm6>
          <v-text-field
            v-model="form.polystone"
            v-validate="'numeric|max:4'"
            data-vv-name="(Finition Ext) Polystone"
            :class="{ error: errors.has('(Finition Ext) Polystone') }"
            class="mb-1"
            label="POLYSTONE mm"
            type="number"
            :disabled="!form.idc_exterior_finishing"
            outlined
            hide-details
          />
        </v-flex>

        <v-layout justify-space-between>
          <v-flex sm6>
            <v-layout>
              <v-radio-group
                v-model="form.exterior_finishing_type"
                class="mb-0 mt-0"
                hide-details
                row
                :disabled="!form.idc_exterior_finishing"
              >
                <v-radio
                  class="mb-1 mt-1"
                  label="PE"
                  value="PE"
                />
                <v-radio
                  class="mb-1 mt-1"
                  label="PP"
                  value="PP"
                />
              </v-radio-group>
            </v-layout>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              v-model="form.pp"
              v-validate="'numeric|max:4'"
              data-vv-name="(Finition Ext) PP/PE"
              :class="{ error: errors.has('(Finition Ext) PP/PE') }"
              class="mt-1 mb-3"
              label="mm"
              type="number"
              :disabled="!form.idc_exterior_finishing"
              outlined
              hide-details
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-text-field
              v-model="form.exterior_finishing_other"
              class="mb-3"
              label="AUTRE"
              maxlength="20"
              hide-details
              outlined
              :disabled="!form.idc_exterior_finishing"
            />
          </v-flex>
        </v-layout>

        <v-layout class="color-select">
          <v-select
            v-model="form.transfer_id"
            :items="transferColors"
            item-text="label"
            item-value="id"
            hide-details
            label="Transfert :"
            filled
            clearable
            :disabled="!form.idc_exterior_finishing"
          />
          <template v-if="previewTransfer">
            <v-flex
              v-if="previewTransfer.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewTransfer.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewTransfer.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': previewTransfer.rgb_code }"
            />
          </template>
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <v-switch
          v-model="form.idc_interior_finishing"
          hide-details
          label="Finition Intérieure :"
          class="title"
          @change="clearIntFinishingFields"
        />
        <v-layout wrap>
          <v-radio-group
            v-model="form.interior_finishing_type"
            class="mb-0 mt-0"
            hide-details
            row
            :disabled="!form.idc_interior_finishing"
          >
            <v-radio
              class="mb-1 mt-1"
              label="PLASTA"
              value="PLASTA"
            />
            <v-radio
              class="mb-1 mt-1"
              label="EVA"
              value="EVA"
            />
          </v-radio-group>
          <v-flex xs12>
            <v-layout class="mt-2 mb-4">
              <v-text-field
                v-model="form.interior_finishing_other"
                label="AUTRE"
                hide-details
                maxlength="20"
                outlined
                :disabled="!form.idc_interior_finishing"
              />
            </v-layout>
          </v-flex>
        </v-layout>
        <h3 class="mb-5">
          Épaisseur :
        </h3>
        <v-flex xs12>
          <v-layout>
            <v-flex>
              <v-text-field
                v-model="form.skin"
                class="mb-3"
                label="PEAU"
                hide-details
                maxlength="20"
                outlined
                :disabled="!form.idc_interior_finishing"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout
          mb-1
          class="color-select"
        >
          <v-select
            v-model="form.thermo_color_id"
            :items="thermoColors"
            item-text="label"
            item-value="id"
            hide-details
            label="THERMO :"
            filled
            clearable
            :disabled="!form.idc_interior_finishing"
          />
          <template v-if="previewThermoColor">
            <v-flex
              v-if="previewThermoColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewThermoColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewThermoColor.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': '#' + previewThermoColor.rgb_code }"
            />
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-switch
      class="mt-0"
      hide-details
      label="Prévisualisation"
    />
    <v-simple-table>
      <thead>
        <tr>
          <th class="text-center">
            SANGLES
          </th>
          <th class="text-center">
            Couleur
          </th>
          <th class="text-center">
            Taille
          </th>
          <th class="text-center">
            Type
          </th>
          <th class="text-center">
            Coussin
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>S1</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s1_size"
              :items="dropdowns.s1_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s1_type"
              :items="dropdowns.s1_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s1_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S2</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s2_size"
              :items="dropdowns.s2_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s2_type"
              :items="dropdowns.s2_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s2_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S3</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s3_size"
              :items="dropdowns.s3_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s3_type"
              :items="dropdowns.s3_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s3_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S4</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s4_size"
              :items="dropdowns.s4_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s4_type"
              :items="dropdowns.s4_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s4_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S5</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s5_size"
              :items="dropdowns.s5_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s5_type"
              :items="dropdowns.s5_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s5_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S6</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s6_size"
              :items="dropdowns.s6_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s6_type"
              :items="dropdowns.s6_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s6_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
        <tr>
          <th>S7</th>
          <td>
            <v-layout align-center>
              <v-select
                label
                filled
                clearable
                hide-details
                :items="['BLANC', 'NOIR']"
              />
            </v-layout>
          </td>
          <td>
            <v-select
              v-model="form.s7_size"
              :items="dropdowns.s7_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-select
              v-model="form.s7_type"
              :items="dropdowns.s7_type"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
            />
          </td>
          <td>
            <v-text-field
              v-model="form.s7_cushion"
              maxlength="45"
              hide-details
              outlined
              clearable
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UpperLimbOrthosisStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType",
      thermoColors: "colors/getTHERMOType",

      dropdowns: "dropdowns/getUpperLimbOptions"
    }),

    // Returns transfer textures
    previewTransfer() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    },

    previewThermoColor() {
      return this.thermoColors.find(
        color => color.id == this.form.thermo_color_id
      );
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear exterior finishing fields
    clearExtFinishingFields() {
      this.form.aquaplast = null;
      this.form.sansplint = null;
      this.form.polystone = null;
      this.form.exterior_finishing_type = null;
      this.form.pp = null;
      this.form.exterior_finishing_other = null;
      this.form.transfer_id = null;
    },

    // Clear interior finishing fields
    clearIntFinishingFields() {
      this.form.interior_finishing_type = null;
      this.form.interior_finishing_other = null;
      this.form.skin = null;
      this.form.thermo_color_id = null;
    }
  }
};
</script>

<style lang="scss">
.upper-limb-orthosis-step-one {
  .checkbox-input-container {
    position: relative;
    margin-top: 30px;
    .v-input {
      margin-top: 0;
    }
    .checkbox-input {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      &.not-mm {
        max-width: 160px !important;
      }
    }
  }
  .v-btn {
    background-color: #006064 !important;
    color: white !important;
  }
}
</style>
